import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import SelectionsDisplayAccess from './SelectionsDisplayAccess'
import PageAccessWrapper from '../Accessibility/Page/PageAccessWrapper'
import SelectionsDisplayNavAccess from './SelectionsDisplayNavAccess'
import { HIGHLIGHT, MAINSLIDER, SLIDER, STRIPE } from '../constants/selectionTypes'
import { PROGRAM_SELECTIONSDISPLAY_ITEMS, PROGRAM_SELECTIONSDISPLAY_ORDER } from '../constants/state'

const mapStateToProps = (state, ownProps) => ({
    order: getData(state, PROGRAM_SELECTIONSDISPLAY_ORDER),
    items: getData(state, PROGRAM_SELECTIONSDISPLAY_ITEMS)
})

const PageFrontAccess = ({
    order,
    items,
}) => {
    let filteredOrder = []

     // ToDo: SHOWTIMES & ADVERTISEMENT
    if(order) {
        filteredOrder = order.filter( id => {
            const type =  items[id].type
            return  type === MAINSLIDER || type === SLIDER || type === STRIPE || type === HIGHLIGHT
        })
    }


    return (
        <PageAccessWrapper>
            <SelectionsDisplayNavAccess 
                order={filteredOrder}
                items={items}
            />

            <SelectionsDisplayAccess 
                order={filteredOrder}
                items={items}
            />
        </PageAccessWrapper>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(PageFrontAccess)